function Slidebar() {
    return <h1>Slidebar</h1>;
}

export default Slidebar;
